import { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Box,
  Card,
  CardHeader,
  IconButton,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate, useParams } from "react-router-dom";
import { fetchDataById, putData } from "../../../api/Services";
import { ArrowBack } from "@mui/icons-material";
import { GeneralCoverageForm } from "./components/generalCoverageForm";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";

const EditGeneralCoverage = () => {
  const navigate = useNavigate();
  const params = useParams();
  const paramId = params.id;
  const [coverageData, setCoverageData] = useState(null);
  const { setCircleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();

  useEffect(() => {
    const fetchData = async () => {

      if (paramId) {
        setCircleLoading(true);
        try {
          await fetchDataById(`/reference/general/coverage/${paramId}`).then((res) => {
            const responseData = res?.data?.coverage;
            setCoverageData((prevData) => ({
              ...prevData,
              name: responseData?.name,
              description: responseData?.description,
              coverageType: {value: responseData?.coverageType?.id, label: responseData?.coverageType?.keyName },
              policyTypeId: {value: responseData?.policyType?.id, label: responseData?.policyType?.keyName },
              productId: {value: responseData?.product?.id, label: responseData?.product?.keyName },
              autoApply: responseData?.autoApply,
              mandatory: responseData?.mandatory,
              active: responseData?.isActive,

              //status
              nameStatus: responseData?.name ? "success" : "unchecked",
              descriptionStatus: responseData?.description ? "success" : "unchecked",
              coverageTypeStatus: responseData?.coverageType?.id ? "success" : "unchecked",
              policyTypeIdStatus: responseData?.policyType?.id ? "success" : "unchecked",
              productIdStatus: responseData?.product?.id ? "success" : "unchecked",
            }));
          });
        } catch (error) {
          console.error(error);
          showSnackbar(error?.response?.data?.message, "error");
        } finally {
            setCircleLoading(false);
        }
      }
    };
  
    fetchData();
  }, [paramId]);


  const handleUpdateCoverage = async (coverageData) => {
    const payload = {      
      name: coverageData?.name,
      description: coverageData?.description,
      coverageTypeId: coverageData?.coverageType?.value,
      autoApply: coverageData?.autoApply,
      mandatory: coverageData?.mandatory,
      isActive: coverageData?.active,
      productId: coverageData?.productId?.value,
      policyTypeId: coverageData?.policyTypeId?.value   
    };
    try {
      const response = await putData(`/reference/general/coverage/${paramId}`, payload);
      if(response?.success){
        navigate("/general-master/general-coverage");
        showSnackbar(response?.message, "success")
      }
      else{
        showSnackbar("Error updating","error");
      }
    } catch (error) {
      console.error("Error fetchin data",error)
      showSnackbar(error?.response?.data?.message, "error");
    }
    finally{
      setCircleLoading(false)
    }
        
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton
                  onClick={() => navigate("/general-master/general-coverage")}
                >
                  <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Edit Coverage details
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    Update Coverage details here.
                  </MaterialTypography>
                </Stack>
              </Stack>
            </Stack>
          }
        />
        <Box>
          <GeneralCoverageForm onsubmit={handleUpdateCoverage} editCoverageData={coverageData} />
        </Box>
      </Card>
    </DashboardLayout>
  );
};

export default EditGeneralCoverage;
